var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckSolid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m3.429-2e-7c-1.891 0-3.429 1.538-3.429 3.429v17.14c0 1.891 1.538 3.429 3.429 3.429h17.14c1.891 0 3.429-1.538 3.429-3.429v-17.14c0-1.891-1.538-3.429-3.429-3.429zm14.62 9.482-6.857 6.857c-0.5036 0.5036-1.318 0.5036-1.816 0l-3.429-3.429c-0.5036-0.5036-0.5036-1.318 0-1.816 0.5036-0.4982 1.318-0.5036 1.816 0l2.518 2.518 5.946-5.952c0.5036-0.5036 1.318-0.5036 1.816 0 0.4982 0.5036 0.5036 1.318 0 1.816z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSolid);
export default __webpack_public_path__ + "static/media/check-solid.aadc551dd41b756bfa8c4fb70621c13c.svg";
export { ForwardRef as ReactComponent };